import { React, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
// import {Link } from 'react-router-dom';
import "../projects/projects.css";
import { Box, Typography } from "@mui/material";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-number-input";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

export const Postinternship = () => {
  let params = useParams();
  let navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [data, setData] = useState({});
  const [skills, setSkills] = useState([]);
  const [errors, setErrors] = useState({});
  const [phoneValue, setPhoneValue] = useState("");
  const [companyLogoImage, setCompanyLogoImage] = useState("");
  const [internshipType, setInternshipType] = useState("");
  useEffect(() => {
    if (params?.internshipId) {
      api
        .get(`/internships/by-id/${params.internshipId}`)
        .then((res) => {
          if (res.data) {
            console.log("internship for edit", res.data);

            // let temp = {
            //   companyName: res.data?.companyName,
            //   pay: res.data?.pay,
            //   location: res.data?.location,
            //   duration: res.data?.duration,
            //   url: res.data?.url,
            //   description: res.data?.description,
            // };
            // console.log("temp", temp);
            setData(res?.data?.generalData);
            setSkills(res?.data?.skills);
            setCompanyLogoImage(res?.data?.companyLogoImage);
            setInternshipType(res?.data?.generalData?.internshipType);
            // setTags(res.data?.tags);
          }
        })
        .catch((err) => console.log);
    }
  }, []);
  const onChange = (e) => {
    let temp = Object.assign(data, { [e.target.name]: e.target.value });
    setData(temp);
    console.log("updated data>> ", temp);
    if (e.target.name == "skillsText") {
      const Array = e.target.value?.split(",");
      let Array2 = Array.filter((arr) => arr !== "");
      setSkills(Array2);
    }
  };
  useEffect(() => {
    let e = {
      target: {
        name: "contact",
        value: phoneValue,
      },
    };
    onChange(e);
  }, [phoneValue]);
  const uploadLogoImage = async (e) => {
    console.log(e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const dataa = new FormData();
      dataa.append("file", files[0]);
      dataa.append("upload_preset", "bpyoqbty");
      console.log("dataa", dataa);

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dqmbkvawu/image/upload",

        {
          method: "POST",
          body: dataa,
        }
      );
      const file = await res.json();
      console.log("response from cloudinary>>>", file);
      setCompanyLogoImage(file?.secure_url);
      // setHostelImage(file?.secure_url);

      // let e2 = { target: { name: "hostelImage", value: file?.secure_url } };
      // onChange(e2);
    }

    // console.log("file profie image>>> ", file);
  };
  const submitData = (e) => {
    // return;
    console.log("submitting", data);
    e.preventDefault();
    let errs = {};
    if (!companyLogoImage) {
      errs.companyLogo = "required";
    }
    if (!data.companyName) {
      errs.companyName = "required";
    }
    if (!data.contact) {
      errs.contact = "required";
    }
    if (!data.internshipTitle) {
      errs.internshipTitle = "required";
    }
    if (!data.industry) {
      errs.industry = "required";
    }
    if (!data.internshipType) {
      errs.internshipType = "required";
    }
    if (!data.duration) {
      errs.duration = "required";
    }
    if (!data.noOfPositions) {
      errs.noOfPositions = "required";
    }
    if (!data.stipend && internshipType != "Unpaid Internship") {
      errs.stipend = "required";
    }
    if (!data.workingHours) {
      errs.workingHours = "required";
    }
    if (!data.city) {
      errs.city = "required";
    }
    if (!data.state) {
      errs.state = "required";
    }
    if (!data.lastDateToApply) {
      errs.lastDateToApply = "required";
    }
    if (new Date(data.lastDateToApply) < new Date(Date.now())) {
      errs.lastDateToApply = "Old date not allowed";
    }
    if (!data.url) {
      errs.url = "required";
    }
    if (skills?.length < 1) {
      errs.skillsRequired = "required";
    }
    if (!data.description) {
      errs.description = "required";
    }
    console.log("errs", errs);
    setErrors(errs);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      let body = {
        userId: currentUser?.id,
        generalData: data,
        companyLogoImage,
        skills,
      };
      if (params?.internshipId) {
        api
          .put(`/internships/update/${params?.internshipId}`, body)
          .then((res) => {
            if (res.data) {
              Swal.fire("internship Updated Successfully!", "", "success");
              navigate("/my-internships");
            }
          })
          .catch((err) => {
            // alert("internship post failed");
            swalWithBootstrapButtons.fire(
              "Internship Updation Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      } else {
        console.log("submitting data", body);
        api
          .post("/internships", body)
          .then((res) => {
            console.log(res.data);
            Swal.fire("intership Uploaded Successfully!", "", "success");
            let notifBody = {
              userId: currentUser?.id,
              text: `${currentUser?.name} post new internship.`,
            };
            api
              .post("/notifications", notifBody)
              .then((re) => console.log("notif", re.data));
            navigate("/internships");
          })
          .catch((err) => {
            console.log(err);
            swalWithBootstrapButtons.fire(
              "Internship Submission Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      }
    }
  };

  return (
    <Box>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        <Box className="col-md-12 col-12">
          <Box className=" p-4">
            <Typography
              variant="h5"
              sx={{ fontSize: "600", marginBottom: "20px" }}
            >
              {params?.internshipId
                ? "Edit your Internship"
                : "Post an Internship"}
            </Typography>
            <Box>
              <Box className="row">
                <Box
                  className="col-12 col-sm-12 col-md-4"
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <input
                    type="file"
                    className="text-feild input__field__asc"
                    id="companyLogo"
                    placeholder="Select Company Logo"
                    name="companyLogo"
                    required
                    onChange={(e) => uploadLogoImage(e)}
                  />
                  {errors.companyLogo && (
                    <p className="error__para">{errors.companyLogo}</p>
                  )}
                  <Box
                    sx={{
                      width: "100px",
                      height: "100px",
                      border: "1px solid lightgray",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {companyLogoImage ? (
                      <img
                        src={companyLogoImage}
                        style={{ height: "100%", width: "100%" }}
                      />
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                        }}
                      >
                        Company Logo
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    className="text-feild input__field__asc"
                    id="companyName"
                    placeholder="Company Name"
                    name="companyName"
                    required
                    onChange={(e) => onChange(e)}
                    defaultValue={data?.companyName}
                  />
                  {errors.companyName && (
                    <p className="error__para">{errors.companyName}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  {/* <input
                    className="text-feild input__field__asc"
                    id="contact"
                    placeholder="Contact number"
                    name="contact"
                    required
                    onChange={(e) => onChange(e)}
                  /> */}
                  <PhoneInput
                    placeholder=" Contact No."
                    className=" input__field__asc text-feild firstBox_of_projects "
                    //value={phoneValue}
                    onChange={(value) => setPhoneValue(value)}
                  />
                  {errors.contact && (
                    <p className="error__para">{errors.contact}</p>
                  )}
                </Box>
              </Box>
              <Box className="row">
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    className="text-feild input__field__asc"
                    id="internshipTitle"
                    placeholder="Internship title"
                    name="internshipTitle"
                    required
                    defaultValue={data?.internshipTitle}
                    onChange={(e) => onChange(e)}
                  />
                  {errors.internshipTitle && (
                    <p className="error__para">{errors.internshipTitle}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  {/* <input
                    className="text-feild input__field__asc"
                    id="industry"
                    placeholder="Industry"
                    name="industry"
                    required
                    onChange={(e) => onChange(e)}
                  /> */}
                  <select
                    className="text-feild input__field__asc"
                    name="industry"
                    onChange={(e) => onChange(e)}
                  >
                    <option value="">Industry</option>
                    <option value="Information technology">
                      Information technology
                    </option>
                    <option value="Automobile">Automobile</option>
                    <option value="Ecommerce">Ecommerce</option>
                    <option value="Digital Marketing">Digital Marketing</option>
                    <option value="Engineering">Engineering</option>{" "}
                    <option value="Accounting and textation">
                      Accounting and textation
                    </option>
                  </select>
                  {errors.industry && (
                    <p className="error__para">{errors.industry}</p>
                  )}
                </Box>
                <Box
                  className="col-12 col-sm-12 col-md-4"
                  sx={{
                    display: "flex",
                    alignItems: "left",
                    gap: "10px",
                    flexDirection: "column",
                    justifyContent: "center",
                    paddingTop: "10px",
                  }}
                >
                  <select
                    name="internshipType"
                    id="internshipType"
                    onChange={(e) => {
                      onChange(e);
                      setInternshipType(e.target.value);
                    }}
                    className="input__field__asc"

                    // defaultValue={boatGeneralDetails?.Style}
                  >
                    <option>Internship Type</option>
                    <option value="Paid Internship">Paid Internship</option>
                    <option value="Unpaid Internship">Unpaid Internship</option>
                    <option value="Partially Paid Internship">
                      Partially Paid Internship
                    </option>
                  </select>
                  {errors.internshipType && (
                    <p className="error__para">{errors.internshipType}</p>
                  )}
                </Box>
              </Box>
              <Box className="row">
                <Box className="col-12 col-sm-12 col-md-4">
                  {/* <input
                    className="text-feild input__field__asc"
                    id="duration"
                    placeholder="Internship duration"
                    name="duration"
                    required
                    onChange={(e) => onChange(e)}
                  /> */}
                  <select
                    className="text-feild input__field__asc"
                    name="duration"
                    onChange={(e) => onChange(e)}
                  >
                    <option value="">duration</option>
                    <option value="one month">one month</option>
                    <option value="two month">two month</option>
                    <option value="three month">three month</option>
                    <option value="four month">four month</option>
                    <option value="five month">five month</option>
                    <option value="six month">six month</option>
                  </select>
                  {errors.duration && (
                    <p className="error__para">{errors.duration}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    className="text-feild input__field__asc"
                    id="noOfPositions"
                    placeholder="Total number of positions"
                    name="noOfPositions"
                    type="number"
                    defaultValue={data?.noOfPositions}
                    min="0"
                    required
                    onChange={(e) => onChange(e)}
                  />
                  {errors.noOfPositions && (
                    <p className="error__para">{errors.noOfPositions}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    type="number"
                    min="0"
                    className="text-feild input__field__asc"
                    id="stipend"
                    placeholder={
                      internshipType == "Unpaid Internship"
                        ? "Stipend N/A"
                        : "Stipend"
                    }
                    defaultValue={data?.stipend}
                    name="stipend"
                    required
                    onChange={(e) => onChange(e)}
                    disabled={
                      internshipType == "Unpaid Internship" ? true : false
                    }
                  />
                  {errors.stipend && (
                    <p className="error__para">{errors.stipend}</p>
                  )}
                </Box>
              </Box>
              <Box className="row">
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    className="text-feild input__field__asc"
                    id="workingHours"
                    placeholder="Working Hours"
                    name="workingHours"
                    required
                    defaultValue={data?.workingHours}
                    onChange={(e) => onChange(e)}
                  />
                  {errors.workingHours && (
                    <p className="error__para">{errors.workingHours}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  {/* <input
                    className="text-feild input__field__asc"
                    id="city"
                    placeholder="City"
                    name="city"
                    required
                    onChange={(e) => onChange(e)}
                  /> */}
                  <select
                    name="city"
                    className="text-feild input__field__asc"
                    onChange={(e) => onChange(e)}
                    required
                    defaultValue={data?.city}
                  >
                    <option value="" disabled selected>
                      Select City
                    </option>
                    <option value="Islamabad">Islamabad</option>
                    <option value="" disabled>
                      Punjab Cities
                    </option>
                    <option value="Ahmed Nager Chatha">
                      Ahmed Nager Chatha
                    </option>
                    <option value="Ahmadpur East">Ahmadpur East</option>
                    <option value="Ali Khan Abad">Ali Khan Abad</option>
                    <option value="Alipur">Alipur</option>
                    <option value="Arifwala">Arifwala</option>
                    <option value="Attock">Attock</option>
                    <option value="Bhera">Bhera</option>
                    <option value="Bhalwal">Bhalwal</option>
                    <option value="Bahawalnagar">Bahawalnagar</option>
                    <option value="Bahawalpur">Bahawalpur</option>
                    <option value="Bhakkar">Bhakkar</option>
                    <option value="Burewala">Burewala</option>
                    <option value="Chillianwala">Chillianwala</option>
                    <option value="Chakwal">Chakwal</option>
                    <option value="Chichawatni">Chichawatni</option>
                    <option value="Chiniot">Chiniot</option>
                    <option value="Chishtian">Chishtian</option>
                    <option value="Daska">Daska</option>
                    <option value="Darya Khan">Darya Khan</option>
                    <option value="Dera Ghazi Khan">Dera Ghazi Khan</option>
                    <option value="Dhaular">Dhaular</option>
                    <option value="Dina">Dina</option>
                    <option value="Dinga">Dinga</option>
                    <option value="Dipalpur">Dipalpur</option>
                    <option value="Faisalabad">Faisalabad</option>
                    <option value="Ferozewala">Ferozewala</option>
                    <option value="Fateh Jhang">Fateh Jang</option>
                    <option value="Ghakhar Mandi">Ghakhar Mandi</option>
                    <option value="Gojra">Gojra</option>
                    <option value="Gujranwala">Gujranwala</option>
                    <option value="Gujrat">Gujrat</option>
                    <option value="Gujar Khan">Gujar Khan</option>
                    <option value="Hafizabad">Hafizabad</option>
                    <option value="Haroonabad">Haroonabad</option>
                    <option value="Hasilpur">Hasilpur</option>
                    <option value="Haveli Lakha">Haveli Lakha</option>
                    <option value="Jatoi">Jatoi</option>
                    <option value="Jalalpur">Jalalpur</option>
                    <option value="Jattan">Jattan</option>
                    <option value="Jampur">Jampur</option>
                    <option value="Jaranwala">Jaranwala</option>
                    <option value="Jhang">Jhang</option>
                    <option value="Jhelum">Jhelum</option>
                    <option value="Kalabagh">Kalabagh</option>
                    <option value="Karor Lal Esan">Karor Lal Esan</option>
                    <option value="Kasur">Kasur</option>
                    <option value="Kamalia">Kamalia</option>
                    <option value="Kamoke">Kamoke</option>
                    <option value="Khanewal">Khanewal</option>
                    <option value="Khanpur">Khanpur</option>
                    <option value="Kharian">Kharian</option>
                    <option value="Khushab">Khushab</option>
                    <option value="Kot Addu">Kot Addu</option>
                    <option value="Jauharabad">Jauharabad</option>
                    <option value="Lahore">Lahore</option>
                    <option value="Lalamusa">Lalamusa</option>
                    <option value="Layyah">Layyah</option>
                    <option value="Liaquat Pur">Liaquat Pur</option>
                    <option value="Lodhran">Lodhran</option>
                    <option value="Malakwal">Malakwal</option>
                    <option value="Mamoori">Mamoori</option>
                    <option value="Mailsi">Mailsi</option>
                    <option value="Mandi Bahauddin">Mandi Bahauddin</option>
                    <option value="Mian Channu">Mian Channu</option>
                    <option value="Mianwali">Mianwali</option>
                    <option value="Multan">Multan</option>
                    <option value="Murree">Murree</option>
                    <option value="Muridke">Muridke</option>
                    <option value="Mianwali Bangla">Mianwali Bangla</option>
                    <option value="Muzaffargarh">Muzaffargarh</option>
                    <option value="Narowal">Narowal</option>
                    <option value="Nankana Sahib">Nankana Sahib</option>
                    <option value="Okara">Okara</option>
                    <option value="Renala Khurd">Renala Khurd</option>
                    <option value="Pakpattan">Pakpattan</option>
                    <option value="Pattoki">Pattoki</option>
                    <option value="Pir Mahal">Pir Mahal</option>
                    <option value="Qaimpur">Qaimpur</option>
                    <option value="Qila Didar Singh">Qila Didar Singh</option>
                    <option value="Rabwah">Rabwah</option>
                    <option value="Raiwind">Raiwind</option>
                    <option value="Rajanpur">Rajanpur</option>
                    <option value="Rahim Yar Khan">Rahim Yar Khan</option>
                    <option value="Rawalpindi">Rawalpindi</option>
                    <option value="Sadiqabad">Sadiqabad</option>
                    <option value="Safdarabad">Safdarabad</option>
                    <option value="Sahiwal">Sahiwal</option>
                    <option value="Sangla Hill">Sangla Hill</option>
                    <option value="Sarai Alamgir">Sarai Alamgir</option>
                    <option value="Sargodha">Sargodha</option>
                    <option value="Shakargarh">Shakargarh</option>
                    <option value="Sheikhupura">Sheikhupura</option>
                    <option value="Sialkot">Sialkot</option>
                    <option value="Sohawa">Sohawa</option>
                    <option value="Soianwala">Soianwala</option>
                    <option value="Siranwali">Siranwali</option>
                    <option value="Talagang">Talagang</option>
                    <option value="Taxila">Taxila</option>
                    <option value="Toba Tek Singh">Toba Tek Singh</option>
                    <option value="Vehari">Vehari</option>
                    <option value="Wah Cantonment">Wah Cantonment</option>
                    <option value="Wazirabad">Wazirabad</option>
                    <option value="" disabled>
                      Sindh Cities
                    </option>
                    <option value="Badin">Badin</option>
                    <option value="Bhirkan">Bhirkan</option>
                    <option value="Rajo Khanani">Rajo Khanani</option>
                    <option value="Chak">Chak</option>
                    <option value="Dadu">Dadu</option>
                    <option value="Digri">Digri</option>
                    <option value="Diplo">Diplo</option>
                    <option value="Dokri">Dokri</option>
                    <option value="Ghotki">Ghotki</option>
                    <option value="Haala">Haala</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Islamkot">Islamkot</option>
                    <option value="Jacobabad">Jacobabad</option>
                    <option value="Jamshoro">Jamshoro</option>
                    <option value="Jungshahi">Jungshahi</option>
                    <option value="Kandhkot">Kandhkot</option>
                    <option value="Kandiaro">Kandiaro</option>
                    <option value="Karachi">Karachi</option>
                    <option value="Kashmore">Kashmore</option>
                    <option value="Keti Bandar">Keti Bandar</option>
                    <option value="Khairpur">Khairpur</option>
                    <option value="Kotri">Kotri</option>
                    <option value="Larkana">Larkana</option>
                    <option value="Matiari">Matiari</option>
                    <option value="Mehar">Mehar</option>
                    <option value="Mirpur Khas">Mirpur Khas</option>
                    <option value="Mithani">Mithani</option>
                    <option value="Mithi">Mithi</option>
                    <option value="Mehrabpur">Mehrabpur</option>
                    <option value="Moro">Moro</option>
                    <option value="Nagarparkar">Nagarparkar</option>
                    <option value="Naudero">Naudero</option>
                    <option value="Naushahro Feroze">Naushahro Feroze</option>
                    <option value="Naushara">Naushara</option>
                    <option value="Nawabshah">Nawabshah</option>
                    <option value="Nazimabad">Nazimabad</option>
                    <option value="Qambar">Qambar</option>
                    <option value="Qasimabad">Qasimabad</option>
                    <option value="Ranipur">Ranipur</option>
                    <option value="Ratodero">Ratodero</option>
                    <option value="Rohri">Rohri</option>
                    <option value="Sakrand">Sakrand</option>
                    <option value="Sanghar">Sanghar</option>
                    <option value="Shahbandar">Shahbandar</option>
                    <option value="Shahdadkot">Shahdadkot</option>
                    <option value="Shahdadpur">Shahdadpur</option>
                    <option value="Shahpur Chakar">Shahpur Chakar</option>
                    <option value="Shikarpaur">Shikarpaur</option>
                    <option value="Sukkur">Sukkur</option>
                    <option value="Tangwani">Tangwani</option>
                    <option value="Tando Adam Khan">Tando Adam Khan</option>
                    <option value="Tando Allahyar">Tando Allahyar</option>
                    <option value="Tando Muhammad Khan">
                      Tando Muhammad Khan
                    </option>
                    <option value="Thatta">Thatta</option>
                    <option value="Umerkot">Umerkot</option>
                    <option value="Warah">Warah</option>
                    <option value="" disabled>
                      Khyber Cities
                    </option>
                    <option value="Abbottabad">Abbottabad</option>
                    <option value="Adezai">Adezai</option>
                    <option value="Alpuri">Alpuri</option>
                    <option value="Akora Khattak">Akora Khattak</option>
                    <option value="Ayubia">Ayubia</option>
                    <option value="Banda Daud Shah">Banda Daud Shah</option>
                    <option value="Bannu">Bannu</option>
                    <option value="Batkhela">Batkhela</option>
                    <option value="Battagram">Battagram</option>
                    <option value="Birote">Birote</option>
                    <option value="Chakdara">Chakdara</option>
                    <option value="Charsadda">Charsadda</option>
                    <option value="Chitral">Chitral</option>
                    <option value="Daggar">Daggar</option>
                    <option value="Dargai">Dargai</option>
                    <option value="Darya Khan">Darya Khan</option>
                    <option value="Dera Ismail Khan">Dera Ismail Khan</option>
                    <option value="Doaba">Doaba</option>
                    <option value="Dir">Dir</option>
                    <option value="Drosh">Drosh</option>
                    <option value="Hangu">Hangu</option>
                    <option value="Haripur">Haripur</option>
                    <option value="Karak">Karak</option>
                    <option value="Kohat">Kohat</option>
                    <option value="Kulachi">Kulachi</option>
                    <option value="Lakki Marwat">Lakki Marwat</option>
                    <option value="Latamber">Latamber</option>
                    <option value="Madyan">Madyan</option>
                    <option value="Mansehra">Mansehra</option>
                    <option value="Mardan">Mardan</option>
                    <option value="Mastuj">Mastuj</option>
                    <option value="Mingora">Mingora</option>
                    <option value="Nowshera">Nowshera</option>
                    <option value="Paharpur">Paharpur</option>
                    <option value="Pabbi">Pabbi</option>
                    <option value="Peshawar">Peshawar</option>
                    <option value="Saidu Sharif">Saidu Sharif</option>
                    <option value="Shorkot">Shorkot</option>
                    <option value="Shewa Adda">Shewa Adda</option>
                    <option value="Swabi">Swabi</option>
                    <option value="Swat">Swat</option>
                    <option value="Tangi">Tangi</option>
                    <option value="Tank">Tank</option>
                    <option value="Thall">Thall</option>
                    <option value="Timergara">Timergara</option>
                    <option value="Tordher">Tordher</option>
                    <option value="" disabled>
                      Balochistan Cities
                    </option>
                    <option value="Awaran">Awaran</option>
                    <option value="Barkhan">Barkhan</option>
                    <option value="Chagai">Chagai</option>
                    <option value="Dera Bugti">Dera Bugti</option>
                    <option value="Gwadar">Gwadar</option>
                    <option value="Harnai">Harnai</option>
                    <option value="Jafarabad">Jafarabad</option>
                    <option value="Jhal Magsi">Jhal Magsi</option>
                    <option value="Kacchi">Kacchi</option>
                    <option value="Kalat">Kalat</option>
                    <option value="Kech">Kech</option>
                    <option value="Kharan">Kharan</option>
                    <option value="Khuzdar">Khuzdar</option>
                    <option value="Killa Abdullah">Killa Abdullah</option>
                    <option value="Killa Saifullah">Killa Saifullah</option>
                    <option value="Kohlu">Kohlu</option>
                    <option value="Lasbela">Lasbela</option>
                    <option value="Lehri">Lehri</option>
                    <option value="Loralai">Loralai</option>
                    <option value="Mastung">Mastung</option>
                    <option value="Musakhel">Musakhel</option>
                    <option value="Nasirabad">Nasirabad</option>
                    <option value="Nushki">Nushki</option>
                    <option value="Panjgur">Panjgur</option>
                    <option value="Pishin Valley">Pishin Valley</option>
                    <option value="Quetta">Quetta</option>
                    <option value="Sherani">Sherani</option>
                    <option value="Sibi">Sibi</option>
                    <option value="Sohbatpur">Sohbatpur</option>
                    <option value="Washuk">Washuk</option>
                    <option value="Zhob">Zhob</option>
                    <option value="Ziarat">Ziarat</option>
                  </select>
                  {errors.city && <p className="error__para">{errors.city}</p>}
                </Box>
                <Box className="col-12 col-sm-12 col-md-4">
                  {/* <input
                    className="text-feild input__field__asc"
                    id="state"
                    placeholder="Province"
                    name="state"
                    required
                    onChange={(e) => onChange(e)}
                  /> */}
                  <select
                    name="state"
                    required
                    onChange={(e) => onChange(e)}
                    className="text-feild input__field__asc"
                  >
                    <option value="">Province</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Sindh">Sindh</option>
                    <option value="Balochistan">Balochistan</option>
                    <option value="KPK">KPK</option>
                    <option value="AJK">AJK</option>
                    <option value="Gilgit Baltistan">Gilgit Baltistan</option>
                  </select>
                  {errors.state && (
                    <p className="error__para">{errors.state}</p>
                  )}
                </Box>
              </Box>
              <Box className="row">
                <Box className="col-12 col-sm-12 col-md-4">
                  <input
                    className="text-feild input__field__asc"
                    id="lastDateToApply"
                    placeholder="last Date to apply"
                    // placeholder="MM/DD/YYYY"
                    type="text"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    name="lastDateToApply"
                    required
                    onChange={(e) => onChange(e)}
                    defaultValue={data?.lastDateToApply}
                  />

                  {errors.lastDateToApply && (
                    <p className="error__para">{errors.lastDateToApply}</p>
                  )}
                </Box>
                <Box className="col-12 col-sm-12 col-md-8">
                  <input
                    className="text-feild input__field__asc"
                    id="url"
                    placeholder="URL"
                    name="url"
                    required
                    onChange={(e) => onChange(e)}
                    defaultValue={data?.url}
                  />
                  {errors.url && <p className="error__para">{errors.url}</p>}
                </Box>
              </Box>
              <Box className="row">
                <Box className="col-12 col-sm-12 ">
                  <input
                    className="text-feild input__field__asc"
                    id="skillsText"
                    placeholder="skills required, seperate by commas"
                    name="skillsText"
                    required
                    onChange={(e) => onChange(e)}
                  />
                  <p></p>
                  {errors.skillsRequired && (
                    <p className="error__para">{errors.skillsRequired}</p>
                  )}
                  <p>Skills : </p>
                  {skills && (
                    <Box className="tags__container">
                      {skills.map((skill) => (
                        <span>{skill} </span>
                      ))}
                    </Box>
                  )}
                </Box>
              </Box>
              <Box className="row">
                <Box className="col-12 col-sm-12 ">
                  <textarea
                    className="text-feild input__field__asc"
                    id="description"
                    placeholder="description"
                    name="description"
                    defaultValue={data?.description}
                    required
                    onChange={(e) => onChange(e)}
                  />
                  {errors.description && (
                    <p className="error__para">{errors.description}</p>
                  )}
                </Box>
              </Box>
              <button
                className=" asc__submit__form__button cancel__form__btn"
                onClick={() => navigate("/internships")}
              >
                Cancel
              </button>
              <button
                className="asc__submit__form__button mt-3"
                id="submitbutton_of_projects"
                onClick={(e) => submitData(e)}
              >
                {params?.internshipId ? "Update" : "Submit"}
              </button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
